import { render, staticRenderFns } from "./googleIcon.vue?vue&type=template&id=2a7f356e&scoped=true"
import script from "./googleIcon.vue?vue&type=script&lang=js"
export * from "./googleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f356e",
  null
  
)

export default component.exports